import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface AgeConfirmationReturn {
  mode: ComputedRef<InputMode>
  setAgeConfirmation: (value: boolean) => void
}

export const useAgeConfirmation = (): AgeConfirmationReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && tutorApplicationStore.getAgeConfirmation === null))

  const setAgeConfirmation = (value: boolean): void => {
    tutorApplicationStore.setAgeConfirmation(value)
  }

  return {
    mode,
    setAgeConfirmation,
  }
}
